import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {
  data: Data;
  defaultMsg: Data;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.defaultMsg = {
      title: 'Sorry! Access Denied',
      icon: 'lock',
      description:
        'Missing something? Please reach out to your administrator for application permissions'
    };
    this.route.data.subscribe(value => {
      if (value && value['title'] && value['icon'] && value['description']) {
        this.data = value;
      } else {
        this.data = this.defaultMsg;
      }
    });
  }
}
